export class UrlHelper {
	static createQueryParams = (
		values?: Array<{
			key: string;
			value?: string | string[] | null;
			encode?: boolean;
		}>
	) => {
		const query = values
			?.filter(({ value }) => !!value)
			.map(({ value, key, encode }) => {
				return `${key}=${encode && value ? encodeURIComponent(value.toString()) : value}`;
			});

		return query?.length ? '?' + query.join('&') : '';
	};

	static buildUrl = (
		baseUrl: string,
		queryParams: Array<{
			key: string;
			value?: string | string[] | null;
			encode?: boolean;
		}>
	) => {
		return `${baseUrl}${UrlHelper.createQueryParams(queryParams)}`;
	};
}
